export const VALID_PLACEMENTS = ['prepend', 'content', 'append'];
//# sourceMappingURL=config.js.map